import React from 'react';
import Typography from '@material-ui/core/Typography';
import Collapse from '@material-ui/core/Collapse';
import ExpandMore from '@material-ui/icons/ArrowDropDown';
import styled from 'styled-components';

const Title = styled.p`
  font-family: CirceBold;
  font-size: 32px;
  line-height: 48px;
  color: #000000;
  letter-spacing: -0.4px;
  margin: 0;
`;

const ButtonTitle = styled(Typography)`
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 27px;
  display: flex;
  align-items: center;
  color: #878F9D;
  transition: all .3s ease-in-out;
  transform: ${p => p.open ? 'rotate(180deg)' : 'rotate(deg)' };
  svg {
    color: #A1A4B1;
  }
`

const Paper = styled.div`
  background: #FFFFFF;
  padding: 32px;
  p {
    font-family: DINPro;
    font-size: 24px;
    line-height: 32px;
    color: #000000;
    display: flex;
    flex-direction: column;
  }
  @media (max-width: 992px) {
    p {
      font-family: DINPro;
      font-size: 16px;
      line-height: 24px;
      color: #000000;
      display: flex;
      flex-direction: column;
    }
  }
`

const CollapseItem = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  padding: 24px;
  ${p => p.open && 'background: #ededed'};
`;

const CollapseContainer = styled.div`
  margin: 0;
  color: #35435A;
`

export default ({ title, children }) => {
  const [open, setOpen] = React.useState(false);

  function handleClick() {
    setOpen(!open);
  }

  return (
    <CollapseContainer>
      <CollapseItem open={open} onClick={handleClick}>
        <Title>{title}</Title>
        <ButtonTitle open={open}><ExpandMore /></ButtonTitle>
      </CollapseItem>
      <Collapse in={open} timeout="auto" classes={{ wrapper: 'gutter-padding' }}>
        <Paper>
          {React.createElement('p', {}, [...children])}
        </Paper>
      </Collapse>
    </CollapseContainer>
  );
}